module.exports = __webpack_public_path__ + "static/media/CSCP.c9501806.png";